import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./home.scss";
import Header from "../_Common/header";
import useSeo from "../../hooks/useSeo";
import { Col, Container, Image, Modal, Row } from "react-bootstrap";
import SectionHead from "../_Common/SectionHead";
import WhatsAppFab from "../_Common/WhatsAppFab";

import sailingIcon from "../../assets/img/home/our-fleet/icons/sailing-boat.png";
import boatIcon from "../../assets/img/home/our-fleet/icons/boat.png";
import starIcon from "../../assets/img/home/our-fleet/icons/star.png";
import lightingIcon from "../../assets/img/home/our-fleet/icons/lighting.png";

import sailBoatsImg from "../../assets/img/home/our-fleet/sail-boats.png";
import sailYachtsImg from "../../assets/img/home/our-fleet/sail-yachts.png";
import motorYachtsImg from "../../assets/img/home/our-fleet/motor-yachts.png";
import speedBoatsImg from "../../assets/img/home/our-fleet/speed-boats.png";
import mainSectionBg from "../../assets/img/home/main-section-bg.png";

import luxurySailingExperienceImg from "../../assets/img/home/featured-experiences/luxury-sailing-experience.png";
import elegantMotorYachtImg from "../../assets/img/home/featured-experiences/elegant-motor-yacht.png";
import exclusiveYachtPartyImg from "../../assets/img/home/featured-experiences/exclusive-yacht-party.png";
import sunsetCruiseYachtImg from "../../assets/img/home/featured-experiences/sunset-cruise-yacht.png";
import privateLuxuryYachtImg from "../../assets/img/home/featured-experiences/private-luxury-yacht.webp";

import SunsetCruiseIcon from "../../assets/img/home/featured-experiences/icons/sunset.png";
import speedBoatIcon from "../../assets/img/home/featured-experiences/icons/boat.png";
import privatePartyIcon from "../../assets/img/home/featured-experiences/icons/confetti.png";
import corporateMeetingsIcon from "../../assets/img/home/featured-experiences/icons/discussion.png";
import eventCelebrationsIcon from "../../assets/img/home/featured-experiences/icons/celebration.png";
//import anniversaryIcon from "../../assets/img/home/featured-experiences/icons/party-popper.png";


export default function Home() {
  useSeo({
    title:
      "Yacht Rental in Mumbai at Gateway of India | Book Sailing Mumbai",
    description:
      "Private yacht, sailing and speed boat charters from Gateway of India, Mumbai. Sail yachts, motor yachts, catamarans and speed boats for sunset cruises, birthdays, anniversaries and corporate events — certified crew, open 7 AM to 10 PM.",
    canonical: "https://booksailingmumbai.co.in/",
  });

  // Opening a link like /#experiences directly: the browser's own anchor
  // jump happens before React renders, so scroll once the section exists.
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return undefined;
    const timer = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  // YATCH DATA
  const yachtData = [
    {
      title_icon: sailingIcon,
      title: "Sail Boats",
      capacity: "Traditional Elegance",
      description:
        "Experience the timeless charm of traditional sailing. Perfect for intimate gatherings and peaceful cruising along Mumbai's coastline.",
      tags: "6-8 Guests",
      image: sailBoatsImg,
      icon: "ri-group-line",
    },
    {
      title_icon: boatIcon,
      title: "Sail Yachts",
      capacity: "Sophisticated Luxury",
      description:
        "Elevate your celebration with our spacious luxury sail yachts. Combining traditional sailing with modern amenities for an unforgettable...",
      tags: "15-35 Guests",
      image: sailYachtsImg,
      icon: "ri-group-line",
    },
    {
      title_icon: starIcon,
      title: "Motor Yachts",
      capacity: "Ultimate Prestige",
      description:
        "Experience the pinnacle of luxury with our modern motor yachts. State-of-the-art amenities, climate control, and opulent interiors.",
      tags: "15-25 Guests",
      image: motorYachtsImg,
      icon: "ri-group-line",
    },
    {
      title_icon: lightingIcon,
      title: "Speed Boats",
      capacity: "Thrilling Adventure",
      description: "Feel the adrenaline rush with our high-performance speed boats. Perfect for adventure seekers and quick coastal tours.",
      tags: "6-12 Guests",
      image: speedBoatsImg,
      icon: "ri-group-line",
    },
  ];

  const featuredExperiences = [
    {
      id: "luxury_sailing_experience",
      title_icon: SunsetCruiseIcon,
      title: "Sailing Experience",
      img: mainSectionBg,
      des: "Set sail on a premium yacht and enjoy an unforgettable experience with top-class amenities, perfect for relaxation or a scenic tour of the sea.",
    },
    {
      id: "elegant_motor_yacht",
      title_icon: speedBoatIcon,
      title: "Elegant Motor Yacht",
      img: elegantMotorYachtImg,
      des: "Cruise in style with our luxurious motor yacht. Featuring elegant design, comfortable seating, and advanced navigation systems for an extraordinary journey.",
    },
    {
      id: "exclusive_yacht_party",
      title_icon: privatePartyIcon,
      title: "Exclusive Yacht Party",
      img: exclusiveYachtPartyImg,
      des: "Host a lavish event aboard our beautifully decorated yacht. Perfect for weddings, parties, or any special occasion, complete with premium service and ambiance.",
    },
    {
      id: "sunset_cruise_yacht",
      title_icon: corporateMeetingsIcon,
      title: "Sunset Cruise Yacht",
      img: sunsetCruiseYachtImg,
      des: "Enjoy a stunning sunset over the Arabian Sea aboard a luxury yacht, accompanied by refreshing beverages and soft music for the perfect evening.",
    },
    {
      id: "private_luxury_yacht",
      title_icon: eventCelebrationsIcon,
      title: "Private Luxury Yacht",
      img: privateLuxuryYachtImg,
      des: "Escape to a world of luxury with a private yacht experience. Tailored to your preferences, ideal for personal getaways or intimate celebrations.",
    }
  ];

  // HANDLE FEATURE
  const [show, setShow] = useState(false);
  const [eventCelebrationsData, setEventCelebrationsData] = useState(null);
  const [currentFeaturedIndex, setCurrentFeaturedIndex] = useState(0);
  const [slideDirection, setSlideDirection] = useState("fade"); // 'fade', 'left', 'right'

  const handleNextSlide = () => {
    setSlideDirection("right");
    setCurrentFeaturedIndex((prev) => (prev === featuredExperiences.length - 1 ? 0 : prev + 1));
  };

  const handlePrevSlide = () => {
    setSlideDirection("left");
    setCurrentFeaturedIndex((prev) => (prev === 0 ? featuredExperiences.length - 1 : prev - 1));
  };

  const handleFeature = (data) => {
    setEventCelebrationsData(data);
    setShow(true);
  };

  // CLOSE MODAL
  const handleClose = () => {
    setShow(false);
    setEventCelebrationsData(null);
  };

  const whatsappLinks = {
    sunset_cruise:
      "https://api.whatsapp.com/send/?phone=917666689265&text=Hi! I'd like to enquire about Sunset Cruise.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",

    speed_boat_adventure:
      "https://api.whatsapp.com/send/?phone=917666689265&text=Hi! I'd like to enquire about Speed Boat Adventure.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",

    private_party_yacht:
      "https://api.whatsapp.com/send/?phone=917666689265&text=Hi! I'd like to enquire about Private Party Yacht.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",

    corporate_meetings:
      "https://api.whatsapp.com/send/?phone=917666689265&text=Hi! I'd like to enquire about Corporate Meetings & Events.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",

    event_celebrations:
      "https://api.whatsapp.com/send/?phone=917666689265&text=Hi! I'd like to enquire about Event Celebrations.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",

    anniversary_celebrations:
      "https://api.whatsapp.com/send/?phone=917666689265&text=Hi! I'd like to enquire about Anniversary Celebrations.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",
  };

  const handleBookNow = (book) => {
    const link = whatsappLinks[book.id];

    if (link) {
      window.open(link, "_blank"); // NEW TAB ✔
    } else {
      console.error("No WhatsApp link found for ID:", book.id);
    }
  };

  // Touch/Swipe Logic
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      // Next Slide
      handleNextSlide();
    } else if (isRightSwipe) {
      // Prev Slide
      handlePrevSlide();
    }
  };

  const current = featuredExperiences[currentFeaturedIndex];

  return (
    <React.Fragment>
      <Header />

      {/* HOME SECTION  */}
      <section className="home-section" id="home">
        <Container>
          <div className="home-section-content">
            <h1 data-aos="fade-up" data-aos-delay="80">
              Luxury Yacht &amp; Sailing Experiences – Mumbai
            </h1>
            <p className="lead" data-aos="fade-up" data-aos-delay="160">
              Experience luxurious private sailing with <span className="brand-highlight">Book Sailing Mumbai</span> — perfect for
              celebrations, sunsets, and unforgettable moments.
            </p>
            <div className="home-section-content-btn" data-aos="fade-up" data-aos-delay="240">
              <Link className="btn-paper" to="/full-fleet">
                <span>Explore the Fleet</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
              <button type="button" className="btn-glass" onClick={() => document.getElementById("experiences")?.scrollIntoView({ behavior: "smooth" })}>
                <span>View Experiences</span>
              </button>
            </div>
          </div>
        </Container>

        <div className="scroll-mouse" aria-hidden="true">
          <div className="mouse">
            <div className="wheel"></div>
          </div>
        </div>
      </section>

      {/* FEATURED EXPERIENCE SECTION */}
      <section className="featured-experience-section" id="experiences">
        <Container>
          <SectionHead
            title="Featured Experiences"
            lead="Choose from our curated selection of premium yacht and speed boat experiences"
          />

          <div className="featured-slider" data-aos="fade-up">
            <div
              className="featured-image-wrapper"
              onTouchStart={onTouchStart}
              onTouchMove={onTouchMove}
              onTouchEnd={onTouchEnd}
            >
              <div
                className={`featured-bg-image ${slideDirection}`}
                key={currentFeaturedIndex}
                style={{ backgroundImage: `url('${current.img}')` }}
                role="img"
                aria-label={current.title}
              ></div>
            </div>

            <div className="featured-content-wrapper">
              <p className="featured-counter">
                <span>{currentFeaturedIndex + 1}</span>
                <span className="featured-counter-total">of {featuredExperiences.length}</span>
              </p>

              <div key={currentFeaturedIndex} className={`animate-text ${slideDirection}`}>
                <h3>{current.title}</h3>
                <p>{current.des}</p>
              </div>

              <button
                type="button"
                className="btn-ink"
                onClick={() => {
                  const message = `Hi! I'd like to enquire about ${current.title}`;
                  const url = `https://wa.me/917666689265?text=${encodeURIComponent(message)}`;
                  window.open(url, "_blank");
                }}
              >
                <i className="ri-whatsapp-line"></i>
                <span>Book Now via WhatsApp</span>
              </button>

              <div className="featured-nav">
                <div className="slider-dots" role="tablist" aria-label="Experiences">
                  {featuredExperiences.map((item, idx) => (
                    <button
                      type="button"
                      key={item.id}
                      role="tab"
                      aria-selected={currentFeaturedIndex === idx}
                      aria-label={item.title}
                      className={`dot ${currentFeaturedIndex === idx ? "active" : ""}`}
                      onClick={() => {
                        setSlideDirection(idx > currentFeaturedIndex ? "right" : "left");
                        setCurrentFeaturedIndex(idx);
                      }}
                    ></button>
                  ))}
                </div>
                <div className="slider-controls">
                  <button type="button" className="slider-control" onClick={handlePrevSlide} aria-label="Previous experience">
                    <i className="ri-arrow-left-line"></i>
                  </button>
                  <button type="button" className="slider-control" onClick={handleNextSlide} aria-label="Next experience">
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* OUR FLEET SECTION  */}
      <section className="home-fleet-section" id="our_fleet">
        <Container>
          <SectionHead
            title="Our Fleet"
            lead="Choose from our diverse collection of vessels, each designed for unique experiences on Mumbai's beautiful waters"
          />

          <Row className="g-3 g-lg-4">
            {yachtData.map((item, i) => (
              <Col key={item.title} xs={12} sm={6} lg={3} data-aos="fade-up" data-aos-delay={(i % 4) * 80}>
                <Link to="/full-fleet" className="media-card media-card--portrait">
                  <span className="media-card-img" style={{ backgroundImage: `url(${item.image})` }}></span>
                  <span className="media-card-body">
                    <span className="media-card-meta">{item.tags.replace("-", "–")}</span>
                    <span className="media-card-title">{item.title}</span>
                    <span className="media-card-desc">{item.description}</span>
                  </span>
                  <span className="media-card-arrow"><i className="ri-arrow-right-up-line"></i></span>
                </Link>
              </Col>
            ))}
          </Row>

          <div className="expert-box" data-aos="fade-up">
            <div>
              <h3 className="title">Ready to Set Sail?</h3>
              <p className="subtitle">
                Choose your perfect vessel and create unforgettable memories on
                Mumbai's stunning waters. Expert crew, luxury amenities, and
                exceptional service await.
              </p>
            </div>
            <Link className="btn-ink" to="/full-fleet">
              <span>View Full Fleet Gallery</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </Container>
      </section>

      {/* GET IN TOUCH SECTION */}
      <section className="get-in-touch" id="contact">
        <Container>
          <SectionHead
            title="Contact Us"
            lead="Ready to embark on an unforgettable journey? Contact us to book your luxury yacht experience"
          />

          <div className="spec-row" data-aos="fade-up">
            <div className="spec-cell">
              <span className="spec-label"><i className="ri-map-pin-line"></i>Location</span>
              <p>Gateway of India,<br />Apollo Bandar, Colaba,<br />Mumbai, Maharashtra 400001</p>
            </div>
            <div className="spec-cell">
              <span className="spec-label"><i className="ri-phone-line"></i>Phone</span>
              <p><a href="tel:+917666689265">+91 76666 89265</a></p>
            </div>
            <div className="spec-cell">
              <span className="spec-label"><i className="ri-time-line"></i>Operating Hours</span>
              <p>Monday – Sunday<br />7:00 AM – 10:00 PM</p>
            </div>
          </div>

          <div className="contact-actions" data-aos="fade-up">
            <p className="note">We respond to all inquiries at the soonest. For urgent bookings, please call us directly.</p>
            <div className="contact-actions-btns">
              <a className="btn-ink" href="tel:+917666689265">
                <i className="ri-phone-line"></i>
                <span>Call Us</span>
              </a>
              <a className="btn-line" href="https://wa.me/917666689265" target="_blank" rel="noreferrer">
                <i className="ri-whatsapp-line"></i>
                <span>WhatsApp</span>
              </a>
            </div>
          </div>
        </Container>
      </section>

      {/* EVENT CELEBRATIONS MODAL */}
      <Modal className="event-celebrations-modal" show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{eventCelebrationsData?.title || "Event Celebrations"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="event-celebrations-img">
            {eventCelebrationsData?.img && (
              <Image src={eventCelebrationsData.img} alt={eventCelebrationsData.title} />
            )}
          </div>
          <p className="event-celebrations-desc">{eventCelebrationsData?.des}</p>

          <button type="button" className="btn-ink btn-block" onClick={() => handleBookNow(eventCelebrationsData)}>
            <i className="ri-whatsapp-line"></i>
            <span>Book Now via WhatsApp</span>
          </button>
        </Modal.Body>
      </Modal>

      <WhatsAppFab />
    </React.Fragment>
  );
}
